import {fromEvent, map, Observable, switchMap} from "rxjs";
import {filter, take} from "rxjs/operators";

const verticalThreshold = 10;
export class SwipeUtil {
  constructor(private element: HTMLElement) {
  }

  onSingleSwipeRight(threshold: number): Observable<{ x: number, y: number }> {
    return fromEvent<TouchEvent>(this.element, 'touchstart').pipe(switchMap(touch => {
      return fromEvent<TouchEvent>(this.element, 'touchmove').pipe(
        map(move => {
          return {
            x: move.touches[0].clientX - touch.touches[0].clientX,
            y: move.touches[0].clientY - touch.touches[0].clientY
          }
        }),
        filter(({x, y}) => y < verticalThreshold && x > threshold),
        take(1)
      )
    }));
  }

  onSingleSwipeLeft(threshold: number): Observable<{ x: number, y: number }>  {
    return fromEvent<TouchEvent>(this.element, 'touchstart').pipe(switchMap(touch => {
      return fromEvent<TouchEvent>(this.element, 'touchmove').pipe(
        map(move => {
          return {
            x: touch.touches[0].clientX - move.touches[0].clientX,
            y: touch.touches[0].clientY - move.touches[0].clientY
          }
        }),
        filter(({x, y}) => y < verticalThreshold && x > threshold),
        take(1)
      )
    }));
  }
}
